// eslint-disable-next-line no-restricted-imports
import { SavedSearchModel } from 'types';

// eslint-disable-next-line no-restricted-imports
import Storage from 'common/lib/storage';
import { getLastMemberId } from '../last-session';

export const SIDEBAR_STORAGE_PREFIX = 'sidebarState';
const initialState: SidebarValues = {};

export interface SidebarValues {
  readonly collapsedDrawerSections?: string[];
  readonly idRecentBoards?: string[];
  readonly pinBoardsListSidebar?: boolean;
  readonly showBoardsListSidebar?: boolean;
  readonly savedSearches?: SavedSearchModel[];
}

export const getSidebarValues = (): SidebarValues | null => {
  let retVal = null;

  if (Storage.isEnabled()) {
    const idMe = getLastMemberId();

    if (idMe) {
      const storageKey = `${SIDEBAR_STORAGE_PREFIX}-${idMe}`;
      retVal = Storage.get(storageKey);

      if (retVal === null || typeof retVal !== 'object') {
        // initialize it in case of invalid state
        Storage.set(storageKey, initialState);
        retVal = Storage.get(storageKey);
      }
    }
  }

  return retVal;
};

export const setSidebarValues = (state: SidebarValues) => {
  if (Storage.isEnabled()) {
    const idMe = getLastMemberId();
    if (idMe) {
      const storageKey = `${SIDEBAR_STORAGE_PREFIX}-${idMe}`;
      Storage.set(storageKey, state);
    }
  }
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/application-storage/sidebar.ts